import React, { useState } from "react";
import DateTimePicker, {
  DateTimePickerEvent,
} from "@react-native-community/datetimepicker";
import { Platform } from "react-native";
import { AHText, Box, TouchableBox } from "arkh";
import { DateTime } from "luxon";
import { useTimeZone } from "../../../OS/Timezone";

export function TimePicker(props: {
  date: Date;
  setDate: (event: DateTimePickerEvent | null, date?: Date) => void;
  hide?: boolean;
  maxDate?: Date;
  minDate?: Date;
  disabled?: boolean;
}) {
  if (Platform.OS === "web") {
    const val = DateTime.fromJSDate(props.date).startOf("minute").toISOTime({
      includeOffset: false,
      suppressSeconds: true,
    })!;
    return (
      <Box
        style={{
          width: 130,
          height: 44,
          justifyContent: "center",
        }}
      >
        {props.hide ? null : (
          <Box spaceHorizontal="medium">
            <input
              type="time"
              key={val + ""}
              defaultValue={val}
              onBlur={(e) => {
                const date = DateTime.fromISO(e.target.value);

                if (date.isValid) {
                  props.setDate(
                    null,
                    DateTime.fromISO(e.target.value).toJSDate()
                  );
                }
              }}
            />
          </Box>
        )}
      </Box>
    );
  }
  if (Platform.OS === "android") {
    return (
      <Box space="small">
        <Box
          color={props.hide ? "transparent" : "background"}
          cornerRadius="small"
          style={{ width: 70, height: 40 }}
        >
          {props.hide ? null : (
            <TimePickerAndroid
              disabled={props.disabled}
              date={props.date}
              setDate={props.setDate}
            />
          )}
        </Box>
      </Box>
    );
  }

  return props.hide ? null : (
    <DateTimePicker
      disabled={props.disabled}
      mode="time"
      display="inline"
      maximumDate={props.maxDate}
      minimumDate={props.minDate}
      // Translation TO-DO
      locale="SV"
      style={{
        marginBottom: -9,
        marginTop: -9,
        marginRight: -9,
        marginLeft: -16,
      }}
      value={props.date}
      onChange={props.setDate}
    />
  );
}

const TimePickerAndroid = (props: {
  date: Date;
  setDate: (event: DateTimePickerEvent, date?: Date) => void;
  maxDate?: Date;
  minDate?: Date;
  disabled?: boolean;
}) => {
  const tz = useTimeZone();
  const [show, setShow] = useState(false);
  const onChange = (f: DateTimePickerEvent, selectedDate: Date | undefined) => {
    setShow(false);
    if (selectedDate) {
      props.setDate(f, selectedDate);
    }
  };
  return (
    <TouchableBox
      style={{
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
      }}
      disabled={props.disabled}
      onPress={() => {
        setShow(true);
      }}
    >
      <AHText type="subtitle" style={{ flex: 1, textAlign: "center" }}>
        {props.date
          ? DateTime.fromJSDate(props.date).toLocaleString({
              hour: "2-digit",
              minute: "2-digit",
              timeZone: tz,
            })
          : null}
      </AHText>
      {show && props.date ? (
        <DateTimePicker
          mode="time"
          is24Hour
          onChange={onChange}
          value={props.date}
          maximumDate={props.maxDate}
          minimumDate={props.minDate}
        />
      ) : null}
    </TouchableBox>
  );
};
